import { PERMISSIONS } from './permissions';
import { WALLET_TYPES } from './wallets';

const COMMON_MENU_ITEMS = [
  {
    name: 'Dashboard',
    path: '/',
    permission: 'DASHBOARD_VIEW',
    pageTitle: {
      normal: 'Welcome back,',
      cursive: ''
    }
  },
  {
    name: 'Collections',
    path: '/wallets',
    pageTitle: {
      normal: 'Your',
      cursive: 'wallets'
    },
    tabs: WALLET_TYPES,
    permission: PERMISSIONS.BALANCE_VIEW,
    hasSubRoutes: true
  },

  {
    name: 'Transactions',
    path: '/transactions',
    permission: PERMISSIONS.TRANSACTIONS_VIEW,
    pageTitle: {
      normal: 'Your',
      cursive: 'transactions'
    }
  },
  {
    name: 'Settlement',
    path: '/settlement',
    permission: PERMISSIONS.SETTLEMENTS_VIEW,
    pageTitle: {
      normal: 'Settlements',
      cursive: 'accounts'
    }
  },
  {
    name: 'Disputes',
    path: '/disputes',
    permission: PERMISSIONS.DISPUTES_VIEW,
    pageTitle: {
      normal: 'All',
      cursive: 'disputes'
    }
  }
];

export { COMMON_MENU_ITEMS };
